import React from 'react';
//import SignUp from '../../components/SignUp';
import Footer from '../../components/MFooter';
//import Loading from '../../components/Loading';

import FormInput from '../../components/FormInput';
import { Link } from 'react-router-dom';

// verificar colocar for=ID nos label
import {Error} from '../../components/Erro';
import useForm from '../../hooks/useForm';
import useAuth from '../../hooks/useAuth';
import {useFetch} from '../../hooks/useFetch';
import { useState } from 'react';
import {ConfirmPasswordInput} from '../../components/auth';
import {sortModos} from '../../utils/djSort';
import "./register.css";

import {municipios_de_atuacao, ma_municipios, ma_escolas,
       br_estados} from "./dicionarios";

function Register () {
  return (
    <div>
	  <HelpPage/>

      <SignUp />

      <Footer />

    </div>
  );
}

export default Register;



function HelpPage(){
	//const [help,setHelp] = useState(false)
	// https://youtu.be/U6ZtGESJmMk
	/*
		<iframe
		src="https://drive.google.com/file/d/1M-MjIALpRATzNs01GwVzTy75CaHIJSPl/preview"
		title = "Video de Ajuda para fazer o cadastro"
		width="100%"
		height="480"/>
	*/
	return (<div className="wrapper">
		<iframe
			title="Video"
			id="playerid"
			type="text/html"
			/*width="100%" height="100%"*/
			width="100%"
			height="400px"
			src={`https://www.youtube.com/embed/U6ZtGESJmMk?autohide=2&autoplay=0&rel=0&showinfo=0?ecver=2&color=red&enablejsapi=1&origin=https://inovaonline.vercel.app`}
			rel={0}
			allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; autoplay"
			frameBorder={0}
			allowFullScreen={true}
		/>
	</div>)
}

function SignUp(){
    // console.dir(data)
    const { values, handleChange:_handleChange} = useForm({
      initialValues: {
          nome:"",
          email:"",
          username:"",
          whatsapp:"",
          estado:"Maranhão",
          estado_out:"",
          municipio:"",
          municipio_out:"",
          municipio_out_out:"",
          //cidade:"",
          bairro:"",
          escola:"",
          escola_out:"",
          nascimento:"",

          idade:'', //<<
          nao_tem_cpf:false,
          cpf:"",
          deficiente:false,
          qual_deficiencia:"",
          cep:"",
          escolaridade:"",
          escolaridade_out:"",
          /*
          falta criar
          Gênero  (desativado)

            casa (desativado)
            cep  (desativado)
          Se é aluno
          Se é professor
          */
          password: "",
          passwordConfirm: "",

          temp:{},

          atuacao:"",
          atuacao_out:"",
          atua_escola:"",

      }
  });

  const handleChange = (event) => {
    if (event.target.name === 'cpf'){
        const value=event.target.value.replace(/\D/g,'')
        if (value.length>10){
            event.target.value = value.slice(0,3)+"."+
            value.slice(3,6)+"."+
            value.slice(6,9)+"-"+
            value.slice(9,11)
        }
    }
    if (event.target.name === 'cep'){
        const value=event.target.value.replace(/\D/g,'')
        if (value.length>5){
            event.target.value = value.slice(0,5)+
            "-"+
            value.slice(5,8)
        }
    }

    if (event.target.name === 'nascimento'){
        const aniversario = new Date(event.target.value);
        values.idade = ~~((Date.now() - aniversario) / (31557600000));
        values.temp.dia = event.target.value.split("-")[2] || aniversario.getDate();
        console.log('idade=',values.idade)
        //console.log(event.target.value.split("-"))
    }


    _handleChange(event)
  }
  //const [ok, setOk] = useState(false);
  const { registerUser, error } = useAuth();
  /*
  const { registerUser:registerUser, error } = useAuth();
  const registerUser = (...vars)=>{
      //-dj//console.log('RU ',values)
      _registerUser(...vars)
  }*/
  /*
  const handleChangePass = event => {
    //event.preventDefault()
    handleChange(event);
    handleChange(event);
    const varOK = values.password!=="" && values.passwordConfirm !=="" && values.password===values.passwordConfirm
    setOk(varOK);
    //-dj//console.log("DD",varOK,values.password,values.passwordConfirm);
    //return
  }
  */
  const handleChangeZap = event => {

      const value = event.target.value.replace(/\D/g,'').substring(0,11);;
      //if (value.length>0) { //>="2"989
      let valueMod = value;
      //(98) 9
      if(value.length > 2 && value.length <= 7)  {
        valueMod = "(" + value.slice(0,2) + ") " + value.slice(2,8);
      }
      if(value.length > 7)
        valueMod = "(" + value.slice(0,2) + ") " + value.slice(2,3) + " " + value.slice(3,7) + "-" + value.slice(7,7+4);

      event.target.value = valueMod;
    return handleChange({...event,value});
  }

  const handleRegister = async (e) => {
      e.preventDefault();

      values.email = values.email.toLowerCase()

      await registerUser(values);
  };
  const {data} = useFetch('estados/1/municipios/')
  const [municipios,setMunicipios] = useState(municipios_de_atuacao)
  // console.log('data',data)
  // ATUALIZANDO LISTA DE MUNICIPIOS
  if (!!data && data.municipios.some(mun=>!municipios.includes(mun.nome))) {
      setMunicipios(data.municipios.sort(sortModos.NOME_ALFA).map(x=>x.nome))
  }

  //console.log('Quantidade de municipios: ', municipios.length/*, municipios*/)

  //console.log('Input: ',{...values,password:"********",passwordConfirm:"********"})
  return (<form className="section-sign-in" onSubmit={handleRegister}>
    <section className="section-block">
      <h2 className="title">Matricule-se</h2>
      <div className="wrapper">

        {!!error && <Error error={error.messages}/>}

        <h2 className="title">Sobre Você</h2>

        <div className="form-group form-icon">
          <label className="form-label">Nome completo *</label>
          <FormInput type={"text"}
            placeholder={"Insira seu nome completo"}
            name={"nome"}
            value={values.nome}
            handleChange={handleChange}
            className = {"form-input"}
            required={true}
            pattern={"([a-zA-Zà-úÀ-Ú]+ [a-zA-Zà-úÀ-Ú ]+)"}
            title="Insira o Nome Completo, Somente letras e espaço"
          />
        </div>

        <div className="form-group form-icon">
          <label className="form-label">{"Nascimento: "} *</label>
          <FormInput type={"date"}
            placeholder={"dia/mes/ano"}
            name={"nascimento"}
            value={values.nascimento}
            handleChange={handleChange}
            className = {"form-input"}
            required={true}
            max="2020/10/28"
            min="1900/01/01"
          />
          {!!values.idade &&
            <div className="obs">{`Então você tem ${values.idade} anos`}</div>}
        </div>


        <div className="form-group form-icon">
          {/* <label className="form-label">Como gostaria de ser chamado? *</label> */}
          <label className="form-label">Crie um nome de usuário *</label>
          <FormInput type={"text"}
            placeholder={"Crie um nome de usuário"}
            name={"username"}
            value={values.username.toLowerCase()}
            handleChange={handleChange}
            className = {"form-input"}
            required={true}
            pattern={"([A-Za-z])([A-z0-9]+)"}
            title="Somente letras e números, Começando por uma letra. Não pode ter espaço e nem caracteres especiais"
            minLength={4}
          />
          <div className="dica">
            Dica:
            <li> Somente letras e/ou números </li>
            <li> Começando por uma letra </li>
            <li> No mínimo 4 caracteres </li>
            exemplo: {values.nome ? values.nome.toLowerCase().replace(/\s.*/g,'')+(values.temp.dia||'0dia') : "edu28"}
          </div>
        </div>



        <div className="form-group form-icon">
          <label className="form-label">CPF: *</label>
          {(!values.nao_tem_cpf || values.idade>=18) &&<>
            <FormInput type={"text"}
              placeholder={'xxx.xxx.xxx-xx'}
              pattern="[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}-?[0-9]{2}"
              name={"cpf"}
              value={values.cpf}
              handleChange={handleChange}
              className = {"form-input"}
              required={true}
            />
            <p className={"dica"}>Dica: pode ser só números</p>
          </>
          }
          {values.idade<18 &&
            <>
              <label className="form-label">Não tenho CPF *</label>
              <FormInput type={"checkbox"}
                name={"nao_tem_cpf"}
                value={values.nao_tem_cpf}
                handleChange={handleChange}
                className="form-input-check"
              />
            </>
          }
        </div>

        <div className="form-checkbox">
          <FormInput type={"checkbox"}
            name={"deficiente"}
            value={values.deficiente}
            handleChange={handleChange}
            className="form-input-check"
          />
          <label className="form-label">Sou PcD, pessoa com deficiência</label>
          {!!values.deficiente &&(
            <div className="form-checkbox">
              <textArea type={"text"}
                placeholder={"Gostaria de dizer qual a deficiência?"}
                name={"qual_deficiencia"}
                value={values.qual_deficiencia}
                handleChange={handleChange}
                className = {""}
              />
              <p className={"dica"}>caso contrario pode deixar em branco ou colocar "prefiro não dizer"</p>
            </div>) }
        </div>
        {/*----------------------------------*/}
      </div>
      <div className="wrapper">
        <h2 className="title">Meios de contato</h2>

        <div className="form-group form-icon">
          <label className="form-label">E-mail *</label>
          <FormInput type={"email"}
            placeholder={"Insira o seu melhor e-mail"}
            name={"email"}
            value={values.email.toLowerCase()}
            handleChange={handleChange}
            autoComplete = {"email"}
            className = {"form-input"}
            required={true}
          />
        </div>
        <div className="form-group form-icon">
          <label className="form-label">Whatsapp *</label>
          <FormInput type={"phone"}
            placeholder={"Insira o número com o DDD"}
            name={"whatsapp"}
            value={values.whatsapp}
            handleChange={handleChangeZap}
            autoComplete = {"phone"}
            className = {"form-input"}
            maxLength="16"
            required={true}
          />
        </div>
      </div>
      <div className="wrapper">
        {/*Sobre o endereço do Usuario*/}

        <h2 className="title">Sobre a tua localização</h2>

        <div className="form-group form-icon">
          <label className="form-label">Qual o seu estado? *</label>
          {/* <FormInput type={"text"}
            placeholder={"Insira o nome do seu estado"}
            name={"estado"}
            value={values.estado}
            handleChange={handleChange}
            className = {"form-input"}
            required={true}
            title='Plataforma livre apenas para o estado do Maranhão'
          /> */}

          <select name="estado" required={true}
            value={values.estado}
            onChange={handleChange}
            className = {values.estado!=="Outro"? "form-input" : ""}
          >
            <option disabled="disabled" value="">Escolha uma opção</option>
            {/*<option value="Maranhão">Maranhão</option>*/}
            {  br_estados.map(
              x=>(<Option value={x.nome}/>)
            )
            }
            <option value="" disabled='True'></option>
            <option value="out">Outra Opção</option>
          </select>
          {values.estado==="out" && (<>
            <FormInput type={"text"}
              placeholder={"Outro: diga qual o teu estado"}
              name={"estado_out"}
              value={values.estado_out}
              handleChange={handleChange}
              className = {"form-input"}
              required={true}
              title='Diga qual o teu estado'
            />
          </>)}
          {values.estado!=="Maranhão" && (<>
            <div></div>
            <div className="dica">
              {`Plataforma de uso Livre, ela foi desenhada para uso no estado do Maranhão, caso você seja de outro estado, depois entre em contato conosco, gostaríamos de conversar com você.`}
            </div>
          </>)}
        </div>

        {/* **************************************************************** */}

        <div className="form-group form-icon">
          <label className="form-label">Qual o seu município? *</label>
          {values.estado==="Maranhão" &&
            <select name="municipio" required
              value={values.municipio}
              onChange={handleChange}
              className = {"form-input"}
            >
              <option disabled="disabled" value="">Escolha uma opção</option>
              {/* <OptionAlpha values={municipios}/> */}
              <OptionAlpha values={ma_municipios}/>
              {/* <option disabled="disabled" value="">--</option> */}
              {/* <option value="out">Outra Opção</option> */}
              {/* {municipios.map(x=><option disabled={x.slice(0,2)==="--"?"disabled":""} key={x} value={x}>{x}</option>)} */}
              {/*  */}
              {/* <option value="Codó">Codó</option> */}
              {/* <option value="Timon">Timon</option> */}
            </select>
          }
          {/*(values.municipio==="out" && values.estado==="Maranhão") && (
            <select name="municipio_out" required
            value={values.municipio_out}
            onChange={handleChange}
            className = {values.municipio_out!=="out"? "form-input" : ""}
            >
            <option disabled="disabled" value="">Escolha uma opção</option>
            <OptionAlpha values={ma_municipios}/>
            </select>
          )*/}
          {(values.municipio_out==="out" || (values.estado!=="Maranhão")) && (
            <FormInput type={"text"}
              placeholder={"Insira o teu município ou cidade"}
              name={"municipio_out_out"}
              value={values.municipio_out_out}
              handleChange={handleChange}
              className = {"form-input"}
              required={true}
              title='diga qual o teu município ou cidade'
            />
          )}

        </div>
        {/*
          <div className="form-group form-icon">
          <label className="form-label">Qual o seu município? *</label>
          <FormInput type={"text"}
          placeholder={"Insira o nome do seu município"}
          name={"municipio"}
          value={values.municipio}
          handleChange={handleChange}
          className = {"form-input"}
          required={true}

          />
        </div> */}

        {/* <div className="form-group form-icon">
          <label className="form-label">Qual o seu bairro? *</label>
          <FormInput type={"text"}
          placeholder={"Insira o nome do seu bairro"}
          name={"bairro"}
          value={values.bairro}
          handleChange={handleChange}
          className = {"form-input"}
          required={true}
          />
        </div> */}

        {/* <div className="form-group form-icon">
          <label className="form-label">Qual o CEP do seu bairro? *</label>
          <FormInput type={"text"}
          placeholder={"Insira o CEP do seu bairro"}
          pattern="[\d]{5}-?[\d]{3}"
          name={"cep"}
          value={values.cep}
          handleChange={handleChange}
          className = {"form-input"}
          required={true}
          />
        </div> */}
      </div>
      <div className="wrapper">
        {/*Sobre a escola*/}

        <h2 className="title">Sobre a escola</h2>

        <div className="form-group form-icon">
          <label className="form-label">Você é Professor, Aluno ou Gestor da educação?*</label>
          <select name="atuacao" required
            value={values.atuacao}
            onChange={handleChange}
            className = {values.atuacao!=="Outro"? "form-input" : ""}
          >
            <option disabled="disabled" value="">Escolha uma opção</option>
            <option value="Aluno">Sou Aluno/Estudante</option>
            <option value="Educador">Sou Professor/Educador</option>
            <option value="Gestor">Sou gestor da educação</option>
            <option value="out">Nenhuma das opções anteriores</option>
          </select>
        </div>
        <div className="form-group form-icon">
          {values.atuacao==="out" && (<>
            <label className="form-label">Descreva tua atuação *</label>
            <FormInput type={"text"}
              placeholder={"Sou Agricultor"}
              name={"atuacao_out"}
              value={values.atuacao_out}
              handleChange={handleChange}
              className = {"form-input"}
              required={true}
            />
          </>)}
        </div>

        { ["Educador", 'Gestor'].includes(values.atuacao) && (
          <div className="form-group form-icon">
            <label className="form-label"> Qual o nome da instituição de ensino que você atua? *</label>
            <FormInput type={"text"}
              placeholder={"Insira o nome da sua escola que você atua"}
              name={"atua_escola"}
              value={values.atua_escola}
              handleChange={handleChange}
              className = {"form-input"}
              required={true}
            />
          </div>)}

        <div className="form-group form-icon">
          <label className="form-label">Qual a tua escolaridade? *</label>
          <select name="escolaridade" required
            value={values.escolaridade}
            onChange={handleChange}
            className = {values.escolaridade!=="Outro"? "form-input" : ""}
          >
            <option disabled="disabled" value="">Escolha uma opção</option>
            <option value="EF">Ensino Fundamental</option>
            <option value="EM">Ensino Médio</option>
            <option value="EMT">Ensino Médio Técnico</option>
            <option value="ES">Ensino Superior</option>
            <option value="out">--Outra Opção</option>
          </select>
          {
            values.escolaridade==="out" && (
              <FormInput
                type={"text"}
                placeholder={"Outra: diga qual a tua escolaridade"}
                name={"escolaridade_out"}
                value={values.escolaridade_out}
                handleChange={handleChange}
                className = {"form-input"}
                required={true}
              />
            )
          }
        </div>

        <div className="form-group form-icon">
          <label className="form-label"> Qual o nome da sua ultima escola de formação?  *</label>
          {
            Object.keys(ma_escolas).includes(values.municipio) && (
              <select name="escola" required
                value={values.escola}
                onChange={handleChange}
                className = {values.escola!=="Outro"? "form-input" : ""}
              >
                <option disabled="disabled" value="">Escolha uma opção</option>
                <OptionAlpha values={ma_escolas[values.municipio]}/>
                <option disabled="disabled" value=""></option>
                <option value="out">Outra Opção</option>
              </select>
            )
          }
          {
            (values.escola==="out" || !Object.keys(ma_escolas).includes(values.municipio)) && (
              <FormInput type={"text"}
                placeholder={"Insira o nome da sua escola"}
                name={"escola_out"}
                value={values.escola_out}
                handleChange={handleChange}
                className = {"form-input"}
                required={true}
              />
            )
          }
        </div>
      </div>
    </section>

    <section className="section-block wrapper">
      <h2 className="title">Escolha uma Senha</h2>

      {!!error && <Error error={error.messages}/>}

      <ConfirmPasswordInput type={"password"}
        name={"password"}
        nameConfirm={"passwordConfirm"}
        value={values.password}
        valueConfirm={values.passwordConfirm}
        handleChange={handleChange}
      />

      <div className="form-group form-icon">
        <input type="checkbox" id="bomUso" required/>
        <label htmlFor="bomUso" className="form-label"> Concordo em fazer bom uso da plataforma *</label>
        {/*<label className="form-checkbox"> Concordo com os termos de uso  *</label>*/}
      </div>
      <div className="form-group form-icon">
        <input type="checkbox" id="aceitarTermos" required/>
        <label htmlFor="aceitarTermos" className="form-label"> Concordo com os <Link className="termos" to="/Termos#termo">Termos e Condições, e Política de Privacidade</Link>  *</label>
        {/* <label className="form-checkbox"> Concordo com os termos de uso  *</label> */}
      </div>
      <div className="">
        <button
          className="btn-register btn-light djbtn"
          type={true ? "submit":"none"}
        > Finalizar cadastro </button>

        <Link to='/Login' style={{"width": "100%"}}>
          <button type="button" className="btn-radius-r djbtn">
            Já tenho uma conta
          </button>
        </Link>
      </div>
    </section>
  </form>
  );
}


/*
coisas removidas do forms

    <div className="form-group form-icon">
        <label className="form-label">Gênero *</label>
        <select className="form-input">
            <option  disabled="disabled" value=" ">Selecione seu gênero</option>
            <option value="Feminino">Feminino</option>
            <option value="Masculino">Masculino</option>
            <option value="NaoInfo">Prefiro não informar</option>
        </select>
    </div>


    <div className="form-group form-icon">
        <label className="form-label">Qual o CEP do seu endereço? *</label>
        <FormInput type={"text"}
            placeholder={"Insira o CEP do seu endereço"}
            name={"bairro"}
            value={values.bairro}
            handleChange={handleChange}
            className = {"form-input"}
        />
    </div>


    <div className = "form-group form-icon" >
        <label className="form-label">Escolaridade *</label>
        <select className="form-input">
            <option  disabled="disabled" value=" ">Insira sua escolaridade</option>
            <option value=" Fundamental"="Fundamental"">Ensino Fundamental</option>
            <option value="Medio">Ensino Médio</option>
            <option value="MedTec">Ensino Médio Técnico</option>
            <option value="Superior">Ensino Superior</option>
        </select>
    </div>




*/



function Option({value}){
    return <option disabled={value.slice(0,2)==="--"?"disabled":""} key={value} value={value}>{value}</option>
}
function OptionAlpha({values}){


    function OptGroup({label,values,disabled}){

        return <optgroup label={label} disabled={!!disabled}>
          {values.map(x=><Option value={x}/>)}
        </optgroup>
    }
    const saida = {};

    values.sort(sortModos.ALPHA)

    values.forEach((item, i) => {
        const chave = `${item.trim()[0]}`
        if(!(chave in saida))
            saida[chave]=[]
        saida[chave].push(item.trim())
    });
    // console.log('\n\nSAIDA',saida)
    // return (<></>)

    return (<>
      {
        Object.entries(saida)
        .map(grupo=><OptGroup
          label={grupo[0]}
          values={grupo[1]}
                    />
        )
      }
    </>)
}


/*

Outros tipos de select, nesse tupo é permitido digitar e selecionar
<input list="browsers" />
<datalist id="browsers">
<option value="Chrome"/>
<option value="Firefox"/>
<option value="Internet Explorer"/>
<option value="Opera"/>
<option value="Safari"/>
</datalist>

*/
